import { useTheme } from "@/theme/ThemeProvider";
import { AppButton } from "@/ui/components/AppButton";
import { HIT_TARGET_MIN } from "@/ui/components/listRowA11y";
import {
  FINDER_PRIVACY_DROP_SAVE,
  FINDER_PRIVACY_HANDBACK,
  FINDER_PRIVACY_SAVE_BLOCKED,
  FINDER_PRIVACY_SAVE_BLOCKED_SAVED,
} from "@/ui/finder/finderMode";
import { Text, View } from "react-native";

const actionStyle = { alignSelf: "stretch" as const, minHeight: HIT_TARGET_MIN };

/**
 * Kontaktdaten ohne Datenschutzbestätigung: nicht speichern.
 * Die Pflegekraft gibt erneut an den Finder oder verwirft den Entwurf.
 */
export function FinderPrivacySaveChoice({
  visible,
  caseAlreadySaved,
  onHandBack,
  onDrop,
}: {
  visible: boolean;
  caseAlreadySaved: boolean;
  onHandBack: () => void;
  onDrop: () => void;
}) {
  const { theme } = useTheme();
  if (!visible) return null;
  return (
    <View style={{ gap: theme.space.sm }}>
      <Text
        accessibilityRole="alert"
        style={{ color: theme.color.warningText, fontSize: theme.fontSize.body }}
      >
        {caseAlreadySaved ? FINDER_PRIVACY_SAVE_BLOCKED_SAVED : FINDER_PRIVACY_SAVE_BLOCKED}
      </Text>
      <AppButton style={actionStyle} onPress={onHandBack}>
        {FINDER_PRIVACY_HANDBACK}
      </AppButton>
      <AppButton variant="outline" style={actionStyle} onPress={onDrop}>
        {FINDER_PRIVACY_DROP_SAVE}
      </AppButton>
    </View>
  );
}
